import { type ImageSources, imageSources } from "@luckymenu/core";
import { usePlatform } from "../provider";

/** `src`, `srcSet` and placeholder for a stored image shown `displayWidth` pixels wide. */
export function useImageSources(
	file: { id: string; blurhash?: string | null } | null | undefined,
	displayWidth: number,
): ImageSources | null {
	const { cdnUrl } = usePlatform();
	return file ? imageSources(cdnUrl, file, displayWidth) : null;
}
